/* eslint quotes: 0 */
export default {
  "container": {
    "containerSearchInProgress": "Ricerca del contenitore in corso",
    "noContainersWithSufficientProductQuantityFound": "Non sono stati trovati contenitori con quantità sufficienti del prodotto selezionato.",
    "searchForProductInContainers": "Cerca il prodotto nei contenitori"
  },
  "contractor": {
    "acceptanceDate": "Data di accettazione",
    "all": "Tutte",
    "chooseContractor": "Seleziona appaltatore",
    "chooseEndedStatus": "Mostrare solo conclusi?",
    "chooseSettlementStatus": "Seleziona lo stato della liquidazione",
    "contractor": "Appaltatore",
    "dateOfSampleAndAcceptance": "Data del campione e dell'approvazione",
    "listOfContractorsWorksToBeSettled": "Elenco dei lavori degli appaltatori da liquidare",
    "makeSettlementErrorText": "Liquidazione fallita. Riprova.",
    "noItemsToBeSettled": "Nessun elemento da liquidare",
    "onlyEnded": "Solo completati",
    "serviceCost": "Costo della decorazione",
    "toBeSettled": "Da liquidare",
    "unitPrice": "Prezzo unitario"
  },
  "contractorsSettlementsImportPopup": {
    "importSuccessDesc": "Dati importati dal file XLSX",
    "importSuccessTitle": "Dati importati",
    "importTitle": "Importa elenco dei lavori degli appaltatori da liquidare",
    "importXlsx": "Importa XLSX",
    "xlsxFile": "File XLSX"
  },
  "customer": {
    "addAddress": "Aggiungi indirizzo",
    "addAddressErrorText": "L'aggiunta dell’indirizzo non è riuscita. Riprova.",
    "addAddressSuccessText": "L'indirizzo fornito è stato salvato",
    "addAddressSuccessTitle": "L'indirizzo è stato aggiunto",
    "addContactPerson": "Aggiungi persona di contatto",
    "addContactPersonErrorText": "L'aggiunta del contatto non è riuscita. Riprova.",
    "addContactPersonSuccessText": "Il contatto inserito è stato salvato",
    "addContactPersonSuccessTitle": "Contatto aggiunto",
    "addCustomer": "Aggiungi cliente",
    "addCustomerErrorText": "L'aggiunta del cliente non è riuscita. Riprova.",
    "addCustomerSuccessText": "Il cliente inserito è stato salvato",
    "addCustomerSuccessTitle": "Cliente aggiunto",
    "addErrorText": "Impossibile aggiungere il client",
    "addNewCustomer": "Aggiungi un nuovo cliente",
    "addSuccessText": "È stato creato un client in base ai dati forniti",
    "addSuccessTitle": "Cliente aggiunto",
    "addingContactPersonAvailableAfterCustomerSave": "Sarà possibile aggiungere contatti dopo il salvataggio del cliente.",
    "addingNewCustomer": "Aggiunta di un nuovo cliente",
    "addingShippingAddressAvailableAfterCustomerSave": "Sarà possibile aggiungere indirizzi di consegna dopo il salvataggio del cliente.",
    "addingTransaltionsAvailableAfterCustomerSave": "Sarà possibile aggiungere traduzioni dopo il salvataggio del cliente.",
    "building": "Edificio",
    "buildingNumber": "Numero civico",
    "changePassword": "Modifica password",
    "changeYourPassword": "Modifica la tua password",
    "city": "Località",
    "company": "Azienda",
    "companyName": "Denominazione dell'azienda",
    "contact": {
      "contact": "Contatto"
    },
    "contactAddress": "Indirizzo di contatto",
    "contactPeople": "Contatti",
    "correspondenceAddressSet": "Dati modificati",
    "correspondenceAddressSetDesc": "Imposta l'indirizzo postale",
    "correspondenceInfo": "Dati per la corrispondenza",
    "customerCountryQuestionMark": "Paese del cliente?",
    "customerLogo": "Logo del cliente",
    "customers": "Clienti",
    "customersList": "Elenco dei clienti",
    "deleteAddressConfirmTitle": "Vuoi davvero cancellare questo indirizzo?",
    "deleteAddressErrorText": "La cancellazione dell'indirizzo non è riuscita. Riprova.",
    "deleteAddressSuccessText": "L'indirizzo selezionato è stato cancellato",
    "deleteAddressSuccessTitle": "L'indirizzo è stato cancellato",
    "deleteContactPersonConfirmTitle": "Vuoi davvero cancellare questo contatto?",
    "deleteContactPersonErrorText": "La cancellazione del contatto non è riuscita. Riprova.",
    "deleteContactPersonSuccessText": "Il contatto selezionato è stato cancellato",
    "deleteContactPersonSuccessTitle": "Contatto cancellato",
    "discount": {
      "deliveryDiscount": "Sconto sulla consegna",
      "productDiscount": "Sconto sui prodotti",
      "servicesDiscount": "Sconto sulle decorazioni"
    },
    "edit": "Modifica cliente",
    "editAddress": "Modifica indirizzo",
    "editAddressErrorText": "La modifica dell'indirizzo non è riuscita. Riprova.",
    "editAddressSuccessText": "L'indirizzo specificato è stato modificato",
    "editAddressSuccessTitle": "L'indirizzo è stato modificato",
    "editClientErrorText": "La modifica del cliente non è riuscita. Riprova.",
    "editClientSuccessText": "I dati del cliente sono stati modificati",
    "editClientSuccessTitle": "Cliente modificato",
    "editContactPerson": "Modifica contatto",
    "editContactPersonErrorText": "La modifica del contatto non è riuscita. Riprova.",
    "editContactPersonSuccessText": "Il contatto inserito è stato modificato",
    "editContactPersonSuccessTitle": "Contatto modificato",
    "editPasswordErrorText": "La modifica della password non è riuscita. Riprova.",
    "editPasswordSuccessText": "La password è stata modificata",
    "editPasswordSuccessTitle": "Password modificata",
    "enterCustomerData": "Inserisci i dati del cliente",
    "fountAddresses": "Indirizzi trovati:",
    "getDataFromGUS": "Recupera dati da GUS",
    "getDataFromVIES": "Recupera dati da VIES",
    "houseNumber": "Numero interno",
    "invoiceAddressSet": "Dati modificati",
    "invoiceAddressSetDesc": "I dati di fatturazione sono stati impostati",
    "invoiceAndCorrespondenceAddressSet": "Dati modificati",
    "invoiceAndCorrespondenceAddressSetDesc": "I dati di fatturazione e corrispondenza sono stati impostati",
    "invoiceInfo": "Dati per la fatturazione",
    "invoiceName": "Denominazione sulla fattura",
    "isOrdersInRpogress": "Ordini in corso?",
    "maxAddressSearchResults": "Vengono visualizzati al massimo 50 indirizzi corrispondenti; se non trovi l'indirizzo desiderato, restringi i criteri di ricerca.",
    "newsletterAgreement": "Consenso alla newsletter",
    "noAddressesToDisplay": "Nessun indirizzo da visualizzare",
    "noContactPeopleToDisplay": "Nessun contatto da visualizzare",
    "noCustomerMarchingPhraseFound": "Nessun cliente corrispondente alla stringa fornita",
    "noCustomersToDisplay": "Nessun cliente da visualizzare",
    "noTranslationsForThisClient": "Nessuna traduzione per questo cliente",
    "notFoundInVIESGUSTitle": "Non trovato",
    "notFoundInVIESGUSText": "L'azienda indicata non è stata trovata nel database",
    "offersInProgress": "Offerte in corso",
    "ordersAndOffers": "Ordini e offerte",
    "ordersInProgress": "Ordini in corso",
    "passowrdChange": "Modifica della password",
    "person": "Persona",
    "phoneShortCap": "Tel",
    "profile": "Profilo",
    "removeCustomerConfirmTitle": "Vuoi davvero cancellare questo cliente?",
    "removeCustomerErrorText": "La cancellazione del cliente non è riuscita. Riprova.",
    "removeCustomerSuccessText": "Il cliente selezionato è stato cancellato",
    "removeCustomerSuccessTitle": "Cliente cancellato",
    "removeLogo": "Cancella il logo",
    "searchAddressesByCompanyNameAddressOrContactInfo": "Ricerca gli indirizzi per denominazione dell'azienda, indirizzo o dati di contatto",
    "selectCustomer": "Seleziona cliente",
    "shippingInfo": "Dati per la spedizione",
    "showCustomerDrafts": "Mostra le offerte",
    "showCustomerOrders": "Mostra gli ordini",
    "statistics": "Statistiche",
    "stockReportsNotifications": "Notifiche sugli stock",
    "street": "Via",
    "telephone": "Telefono",
    "termsOfSale": "Condizioni di vendita",
    "unsettledInvoices": "Fatture non liquidate",
    "vatIDNumber": "NIP [c.f./p. IVA]/ VAT ID",
    "verificationIntegrationDisabledDesc": "Il servizio di recupero dati non è attualmente disponibile",
    "verificationIntegrationDisabledTitle": "Servizio non disponibile",
    "withOrdersInProgress": "Con ordini in corso",
    "withoutOrdersInProgress": "Senza ordini in corso",
    "youMustSelectCountryPrefix": "Seleziona il prefisso del paese",
    "youMustSelectCountryPrefixDesc": "Per recuperare i dati è necessario specificare il prefisso del paese",
    "yourAccount": "Tuo account",
    "zipCode": "Codice postale"
  },
  "customerOrdersPopup": {
    "offers": "Offerte del cliente",
    "orders": "Ordini del cliente"
  },
  "dashboard": {
    "customersPopup": {
      "customerEmail": "E-mail",
      "customerName": "Nome del cliente",
      "customerPhone": "Telefono",
      "title": "Invia richieste ai clienti"
    }
  },
  "errorPage": {
    "errorCode": "404",
    "pageDoesNotExist": "La sottopagina selezionata non esiste",
    "tryAgainLaterOrContactAdministrator": "Riprova più tardi o contatta l'amministratore di sistema."
  },
  "inquiries": {
    "addComments": "Aggiungi i tuoi commenti",
    "addFirstProductInstructionInfo": "Aggiungi il tuo primo prodotto cliccando su “+ Prodotto”.",
    "addFirstServiceInstructionInfo": "Aggiungi la tua prima decorazione generale cliccando su “+ Decorazione generale”.",
    "caanotCreateOrder": "Impossibile creare l’ordine",
    "failedToAddProductsToOrder": "Non sono stati aggiunti prodotti all'ordine",
    "executionTime": "Tempo di realizzazione",
    "globalServicesTooltip": "Se più prodotti avranno la stessa decorazione, aggiungi una decorazione generica da qui. In questo caso, addebiteremo solo una volta il costo del setup. Puoi distribuire il numero di decorazioni ordinate ai singoli prodotti.",
    "needExecutionTill": "Da realizzare entro",
    "noComments": "Nessun commento",
    "noDateSelected": "Nessuna scadenza",
    "orderAdditionalInfo": "Note aggiuntive all'ordine",
    "selectExecutionTime": "Seleziona il tempo di realizzazione",
    "trackingNumber": "Numero di tracciamento",
    "unexpectedErrorOccured": "È comparso un problema imprevisto"
  },
  "login": {
    "authError": "Errore di autorizzazione. Si prega di riprovare",
    "emailPlaceholder": "Tuo indirizzo email",
    "loginInProgress": "Accesso in corso...",
    "loginLabel": "Accedi",
    "password": "Password",
    "passwordPlaceholder": "********",
    "register": "Non hai un account?",
    "resetPassword": "Hai dimenticato la password?"
  },
  "noPermissions": {
    "noPermissionsDescription": "Se ritieni che si tratti di un errore, contatta l'amministratore di sistema.",
    "noPermissionsText": "Non sei autorizzato a visualizzare questa pagina",
    "noPermissionsTitle": "Nessuna autorizzazione"
  },
  "order": {
    "addNewDraft": "Aggiungi una nuova offerta",
    "addNewFemenine": "Aggiungi nuova",
    "addNewOrder": "Aggiungi nuovo ordine",
    "addNewShippingAddress": "Aggiungi nuovo indirizzo di spedizione",
    "addedProducts": "Sono stati aggiunti i seguenti prodotti:",
    "addressRemoved": "L'indirizzo precedentemente utilizzato è stato cancellato. Seleziona un nuovo indirizzo.",
    "awaitingInvoice": "in attesa di fatturazione",
    "awaitingProductionComplete": "in attesa del completamento della produzione",
    "awaitingSample": "in attesa di un campione",
    "awaitingSampleAcceptance": "in attesa di approvazione del campione",
    "beeingCollected": "In fase di raccolta",
    "blockade": "Blocco",
    "cartonsMissingInfo": "Potrebbe essere necessario modificare il numero di scatoloni, poiché alcuni prodotti non hanno un numero specifico di pezzi negli scatoloni.",
    "cartonsNumber": "Numero di scatoloni",
    "checkFormDesc": "Durante la convalida sono stati riscontrati degli errori che devono essere corretti. Controllare le schede del modulo e correggere gli errori riscontrati.",
    "checkFormTitle": "Controllare il modulo",
    "chooseShippingAddress": "Selezionare l'indirizzo di spedizione",
    "clientContactPerson": "Persona di contatto del cliente",
    "connectedInvoices": "Fatture correlate",
    "currentDiscountOfCustomer": "Lo sconto salvato nel profilo cliente è",
    "customerAndName": "Cliente e denominazione",
    "customerDiscounts": "Sconti cliente",
    "dashOrderAwaitingShipping": "- ordini in attesa di spedizione",
    "dashReadyForShipping": "- pronti per la spedizione",
    "dateOfIssue": "Data di emissione",
    "deleted": "Cancellati",
    "delivery": "Consegna",
    "download": "Scarica",
    "downloadPDF": "Scarica PDF",
    "downloadPDFforMe": "Offerta per la mia AZIENDA",
    "downloadPDFforMyCustomer": "Offerta per il mio CLIENTE",
    "downloadXls": "Scarica XLS",
    "draftDeleteConfirmTitle": "Vuoi davvero cancellare quest’offerta?",
    "draftDeleteErrorText": "La cancellazione dell'offerta non è riuscita. Riprova.",
    "draftDeleteSuccessText": "L'offerta selezionata è stata cancellata",
    "draftDeleteSuccessTitle": "Offerta cancellata",
    "draftsList": "Elenco delle offerte",
    "duplicateOrder": {
      "questionTextOffer": "Vuoi davvero duplicare l'offerta selezionata?",
      "questionTextOrder": "Vuoi davvero duplicare l’ordine selezionato?",
      "questionTitle": "Conferma l'operazione",
      "successTextOffer": "L'offerta selezionata è stata duplicata con successo",
      "successTextOrder": "L'ordine selezionato è stato duplicato con successo",
      "successTitleOffer": "Offerta duplicata",
      "successTitleOrder": "Ordine duplicato"
    },
    "editDraft": "Modifica offerta",
    "editDraftErrorText": "Impossibile salvare l’offerta",
    "editDraftSaveSuccessText": "L'offerta è stata salvata con successo",
    "editDraftSuccessTitle": "L'offerta è stata salvata",
    "editingOfferFromHPL1": "Stai modificando un'offerta creata per <strong>la tua AZIENDA</strong>. Se desideri trasformarla in una <strong>offerta per il tuo CLIENTE</strong>, clicca ",
    "editingOfferFromHPL2": "qui",
    "editingOfferFromHPL3": "Ricordati di salvare l'offerta dopo questa modifica.",
    "ended": "Conclusi",
    "errors": {
      "shipping_price_not_fetched": "Non è stato possibile aggiornare il prezzo di consegna. Si prega di verificare il prezzo di consegna."
    },
    "files": {
      "addingFile": "Aggiunta del file",
      "deleteFile": "Cancella il file",
      "editFile": "Modifica il file",
      "editFileText": "Inserisci la descrizione aggiornata del file",
      "editFileTitle": "Modifica della descrizione del file",
      "fileEditError": "Si è verificato un errore durante la modifica del file. Riprova.",
      "noFilesToDisplay": "Nessun file associato a questo ordine",
      "noServiceFilesToDisplay": "Nessun file associato a questa decorazione",
      "removeFileDesc": "Quest’operazione non può essere annullata",
      "removeFileTitle": "Vuoi davvero cancellare questo file?",
      "title": "File associati all'ordine",
      "uploadError": "Si è verificato un errore durante l'aggiunta del file"
    },
    "fileSuffixOfferCustomer": "-OFFERTA-CLIENTE",
    "fileSuffixOfferMe": "-OFFERTA-HPL",
    "forAcceptance": "Da accettare",
    "inProduction": "In produzione",
    "includedCustomerDiscount": "Sconto cliente",
    "includedMarkup": "Ricarico",
    "invoicesIssued": "Fatture emesse",
    "lastChange": "ult. modifica",
    "lastItemModified": "Modificati recentemente",
    "lastItemViewed": "Visionati recentemente",
    "nameCheck": {
      "inProgress": "Verifica del nome dell'ordine in corso",
      "inUse": "Il nome dell'ordine selezionato è già utilizzato da altri ordini.",
      "isAvailable": "Il nome dell'ordine selezionato è disponibile"
    },
    "noAddressFound": "Nessun indirizzo selezionato",
    "noAddresses": "Nessun indirizzo",
    "noAddressesForThisClient": "Nessun indirizzo assegnato al cliente.",
    "noContactPeople": "Nessun contatto",
    "noInvoicesConnectedToOrder": "Nessuna fattura associata a questo ordine",
    "nonExistingCustomerText": "Il cliente associato a questo ordine è stato eliminato. Assegna nuovamente un cliente all'ordine.",
    "nonExistingCustomerTitle": "Il cliente selezionato non esiste",
    "noOffersOrOrdersToDisplay": "Nessuna offerta o ordine da visualizzare",
    "noOrderMatchingPhraseFound": "Nessun ordine corrispondente alla stringa inserita",
    "noTagsMatchingGivenPhrase": "Nessuna caratteristica corrispondente alla stringa inserita",
    "number": "Numero",
    "numberOfOrderdProducts": "Numero di prodotti ordinati",
    "offerCurrency": "Valuta dell'offerta",
    "offerLanguage": "Lingua dell'offerta",
    "offerPreparedFor": "Offerta preparata per",
    "offerSubmissionDate": "Data di presentazione dell'offerta",
    "offersToCheck": "Offerte da controllare",
    "orderNumber": "Numero dell'ordine",
    "orderPreparedFor": "Ordine preparato per",
    "orderPreview": "Anteprima dell'ordine",
    "orders": "Ordini",
    "ordersList": "Elenco degli ordini",
    "ordersXlsFilename": "elenco-ordini",
    "paymentDate": "Data di pagamento",
    "paymentDeadline": "Termine di pagamento",
    "pdfDownloadNoticeDesc": "Stai scaricando un'offerta PDF per te stesso. Non inoltrare questo file al tuo cliente.",
    "pdfDownloadNoticeTitle": "Attenzione!",
    "pendingPayment": "In attesa di pagamento",
    "priceChangePopup": {
      "element": "Elemento",
      "new": "Nuovo valore",
      "previous": "Valore precedente",
      "subtitle": "Queste modifiche verranno applicate dopo aver salvato nuovamente l'offerta.",
      "title": "Sono state apportate le seguenti modifiche ai prezzi",
      "type": "Tipo di modifica",
      "types": {
        "globalServiceMultipleFrom": "Moltiplicatore della decorazione globale",
        "globalServicePrice": "Prezzo della decorazione globale",
        "globalServiceSetupPrice": "Prezzo del setup della decorazione globale",
        "product": "Prodotto",
        "serviceMultipleFrom": "Moltiplicatore della decorazione",
        "servicePrice": "Prezzo della decorazione",
        "serviceSetupPrice": "Prezzo del setup della decorazione"
      },
      "changeSource": "Fonte della modifica",
      "sources": {
        "prices": "Listino HPL",
        "customer_prices": "Il tuo listino"
      }
    },
    "productMinQty": "Qtà min.",
    "productsTags": "Caratteristiche dei prodotti",
    "readyForShipping": "Pronto per la spedizione",
    "saveAsOrder": "Invia l'ordine per l'elaborazione",
    "saveAsOrderNoticeDesc": "Una volta salvato come ordine, i dati non possono essere modificati: accertati che tutti i dati inseriti siano corretti.",
    "saveAsOrderNoticeTitle": "Invia l'ordine per la realizzazione",
    "saveDraft": "Salva l'offerta",
    "see": "Visualizza",
    "selectOrder": "Seleziona l'ordine",
    "sent": "Inviati",
    "servicesGenitive": "Decorazioni",
    "shippingAddress": "Indirizzo di spedizione",
    "showAddress": "Mostra indirizzo",
    "showContact": "Mostra contatto",
    "summary": "Riepilogo",
    "toCheckInWarehouse": "Da controllare in magazzino",
    "toCollect": "Da ritirare",
    "toDelete": "Da cancellare",
    "totalCost": "Costo totale",
    "totalDeliveryCostNet": "Costo di consegna (IVA esclusa)",
    "useCustomerDiscounts": "Usa gli sconti cliente",
    "usePartnerPricing": "Usa il tuo listino per questo ordine",
    "valueForPartnerCustomer": "Valore dell'ordine per il cliente",
    "waitingForShipping": "In attesa di spedizione",
    "waitingPurchaseProducts": "In attesa dei prodotti",
    "whoOrders": "Committente",
    "whoOrdersMe": "La mia AZIENDA",
    "whoOrdersMyCustomer": "Il mio CLIENTE",
    "withDeadlineApproaching": "prossimi alla scadenza",
    "yesSave": "Sì, salva",
    "yourDiscounts": "I tuoi sconti",
    "yourPrice": "Il tuo prezzo"
  },
  "price": {
    "addNewPrice": "Aggiungi nuovo prezzo",
    "addNewProductPrice": "Aggiungi nuovo prezzo del prodotto",
    "addNewServicePrice": "Aggiungi nuovo prezzo di decorazione",
    "addNewSetupPrice": "Aggiungi nuovo prezzo di setup",
    "addPrice": "Aggiungi prezzo",
    "addPriceErrorText": "Impossibile aggiungere il prezzo. Riprova.",
    "addPriceSuccessText": "Il prezzo inserito è stato salvato",
    "addPriceSuccessTitle": "Prezzo aggiunto",
    "bruttonPrice": "Prezzo lordo",
    "chosenPriceIsSetupPrice": "Il prezzo inserito è un prezzo di setup",
    "deletePriceConfirmTitle": "Sei sicuro di voler eliminare questo prezzo?",
    "deletePriceErrorText": "Impossibile eliminare il prezzo. Riprova.",
    "deletePriceSuccessText": "Il prezzo selezionato è stato eliminato",
    "deletePriceSuccessTitle": "Prezzo eliminato",
    "differentPriceMultipleFromInfo": "Il moltiplicatore di prezzo \"per pezzo a partire da\" applicato differisce dal moltiplicatore di prezzo corrente ({value} pz.)",
    "editPrice": "Modifica prezzo",
    "export": "Esporta",
    "exportPrices": "Esporta listini prezzi",
    "exportSuccessfull": "Listini prezzi esportati",
    "exportSuccessfullDesc": "I listini prezzi sono stati esportati con successo",
    "importPrices": "Importa listini prezzi",
    "importSuccessfull": "Listini prezzi importati",
    "importSuccessfullDesc": "I listini prezzi sono stati importati con successo",
    "includeSetupPrices": "Includi i prezzi di setup",
    "isSale": "Saldi / Promozione",
    "noPricesFoundForServiceGroup": "Nessun listino prezzi trovato per il gruppo di decorazione selezionato",
    "noPricesToDisplay": "Nessun prezzo da visualizzare",
    "onlyPriceUpdate": "Solo aggiornamento prezzi",
    "pln": "PLN",
    "plnBrutto": "PLN lordo",
    "plnNet": "PLN netto",
    "plnVat": "PLN IVA",
    "price": "Prezzo",
    "priceFlat": "Tariffa fissa",
    "priceBox": "Tariffa per quantità",
    "price25pcs": "fino a 25 pz.",
    "priceFirstBox": "Primo cartone",
    "priceSecondBox": "Secondo cartone",
    "priceNextBox": "Cartone successivo",
    "priceBeforeDicount": "Prezzo prima dello sconto",
    "priceEdit": "Modifica del prezzo",
    "priceFrom": "Prezzo a partire da",
    "priceImportFrom": "Importa prezzi da",
    "priceNet": "Prezzo netto",
    "pricePerItem": "Prezzo per pezzo",
    "pricePerItemFrom": "Prezzo per pezzo a partire da {price} pz.",
    "pricePerItemShort": "Prezzo per pz.",
    "prices": "Prezzi",
    "priceTo": "Prezzo fino a",
    "pricesLists": "Listini prezzi",
    "pricesListsLowCase": "listini prezzi",
    "productGenitive": "del prodotto",
    "productsPricesList": "Listino prezzi dei prodotti",
    "quantityFrom": "Quantità da",
    "quantityTo": "Quantità a",
    "removeAndReplacePrices": "Rimuovi i prezzi e aggiungili di nuovo",
    "savePriceErrorText": "Impossibile modificare il prezzo. Riprova.",
    "savePriceSuccessText": "Il prezzo selezionato è stato modificato",
    "savePriceSuccessTitle": "Prezzo modificato",
    "seePricelist": "Vedi listino prezzi",
    "serviceGenitive": "della decorazione",
    "servicesPriceList": "Listino prezzi decorazioni",
    "servicesPricesList": "Elenco dei prezzi di decorazione",
    "setup": "setup",
    "setupPricesList": "Listino prezzi di setup",
    "supplierPricesFileNamePrefix": "listini-prezzi-fornitore-",
    "unitPricesIn": "prezzi unitari in",
    "vat": "IVA",
    "vatRate": "Aliquota IVA",
    "xlsxFileWithPrices": "File XLSX con i prezzi"
  },
  "product": {
    "addGlobalService": "Decorazione generale",
    "addGlobalServicesPackage": "Pacchetto decorazioni",
    "addProduct": "Prodotto",
    "breakProductsIntoSeparateOffers": "Dividi i prodotti in offerte separate",
    "checkAvailability": "Controlla le prossime consegne",
    "enterAdditionalProductDescriptionOptional": "Digita una descrizione aggiuntiva del prodotto (opzionale)",
    "enterProductNameOrCode": "Inserisci il nome o il codice del prodotto",
    "globalServices": "Decorazioni generali",
    "noProductsMatchingGivenPhrase": "Nessun prodotto corrispondente alla stringa inserita",
    "notIncludedInDiscounts": "Non soggetto a sconti",
    "product": "Prodotto",
    "productCode": "Codice prodotto",
    "productName": "Nome del prodotto",
    "products": "Prodotti",
    "productsCodes": "Codici dei prodotti",
    "selectProduct": "Seleziona un prodotto",
    "totalBeforeDiscount": "Prima dello sconto",
    "totalMarkup": "Di cui ricarico",
    "totalProductsCostNet": "Costo dei prodotti (IVA esclusa)",
    "totalServicesCostNet": "Costo delle decorazioni (IVA esclusa)",
    "useCustomPartnerPrice": "Usa il tuo prezzo",
    "useDefaultPartnerPrice": "Usa il prezzo predefinito"
  },
  "purchase": {
    "addOrderErrorText": "L'aggiunta dell’ordine non è riuscita. Riprova.",
    "editOrderSuccessTitle": "L'ordine è stato salvato",
    "fileDeletedDesc": "Il file selezionato è stato cancellato",
    "fileDeletedTitle": "File cancellato",
    "numberOfPiecesNeeded": "Numero di unità necessarie",
    "removeFileInProgress": "Cancellazione del file",
    "yourOrderSaveSuccessText": "Il tuo ordine è stato salvato"
  },
  "register": {
    "customerTaxNumber": "Partita IVA / Codice Fiscale",
    "login": "Accedi",
    "password": "Password",
    "passwordConfirmation": "Conferma password",
    "passwordReset": {
      "error": "Modifica della password fallita",
      "resetLabel": "Cambia password",
      "resetInProgress": "Salvataggio delle modifiche",
      "success": "Password modificata - ora puoi accedere",
      "title": "Cambia password"
    },
    "passwordResetRequest": {
      "error": "Reimpostazione della password fallita",
      "resetInProgress": "Reimpostazione della password in corso",
      "resetLabel": "Richiedi reimpostazione password",
      "success": "Richiesta di reimpostazione inviata. Se l'e-mail inserita esiste nel sistema, riceverai ulteriori istruzioni nella tua casella di posta.",
      "title": "Reimposta password"
    },
    "registerError": "Registrazione fallita",
    "registerInProgress": "Registrazione in corso",
    "registerLabel": "Registrati",
    "registerSuccess": "Account creato. In attesa di verifica e approvazione.",
    "title": "Crea un account"
  },
  "service": {
    "addService": "Decorazione",
    "addServicesPackage": "Pacchetto decorazioni",
    "addServicesPackageBtn": "Aggiungi pacchetto decorazioni",
    "chooseEmbroideryPosition": "Seleziona la posizione della decorazione",
    "chooseEmbroideryType": "Seleziona il tipo della decorazione",
    "chooseService": "Seleziona la decorazione",
    "chooseServiceGroup": "Scegli il gruppo di decorazione",
    "commonServices": "Decorazioni comuni",
    "complexity": "Livello di complessità",
    "descriptionFoCustomer": "Descrizione per il cliente",
    "detailsOfServiceInOrder": "Dettagli delle decorazioni nell'ordine",
    "downloadLogo": "Scarica il logo",
    "dstNumber": "Numero DST",
    "embroidery": {
      "colors": "Colori della decorazione",
      "height": "ALT",
      "position": "Posizione della decorazione",
      "size": "Dimensione della decorazione (mm)",
      "type": "Tipo di decorazione",
      "width": "LARG"
    },
    "enterServiceNameOrCode": "Inserisci il nome o il codice della decorazione",
    "files": {
      "title": "File della decorazione"
    },
    "findService": "Trova la decorazione corrispondente",
    "noServiceGroupsMatchingPhrase": "Nessun gruppo di decorazione corrisponde alla ricerca",
    "noServicesMatchingPhrase": "Nessuna decorazione corrispondente alla stringa indicata",
    "productionCompleteDate": "Data di completamento della produzione",
    "sample": {
      "sampleAcceptDate": "Data di accettazione del campione",
      "sampleDate": "Data del campione",
      "samplePhotosDateCreated": "Data di aggiunta",
      "samplePhotosDownload": "Scarica",
      "samplePhotosDownloadAll": "Scarica tutto",
      "samplePhotosSeePreview": "Visualizza l'immagine del campione",
      "samplePhotosTitle": "Foto dei campioni",
      "sampleReceiveDate": "Data di ricezione del campione"
    },
    "sampleFiles": {
      "title": "File del campione"
    },
    "samples": {
      "noSamples": "Nessun campione",
      "rejectReason": "Motivo del rifiuto",
      "sample": "Campione",
      "saveBeforeAddingFiles": "Salva l’ordine per poter aggiungere i file",
      "statuses": {
        "accepted": "Accettato",
        "rejected": "Rifiutato"
      },
      "title": "Campioni della decorazione"
    },
    "selectFileWithLogo": "Selezionare il file con il logo",
    "selectService": "Seleziona la decorazione",
    "selectedServiceName": "Decorazione selezionata",
    "service": "Decorazione",
    "serviceCode": "Codice decorazione",
    "serviceGroup": "Gruppo di decorazione",
    "serviceName": "Nome della decorazione",
    "serviceNotFound": "Decorazione non trovata",
    "serviceNotFoundDesc": "Non sono state trovate decorazioni corrispondenti per il gruppo, la complessità e le dimensioni indicate. Prova una configurazione diversa.",
    "servicesPackage": {
      "dates": {
        "date": "Termine",
        "types": {
          "obtaining_at": "Data di ricezione del campione",
          "accepted_at": "Data di approvazione del campione",
          "sample_hpl_accepted_at": "Data di approvazione del campione"
        }
      }
    },
    "servicesPackageHideContents": "Nascondi contenuto",
    "servicesPackageInvalidConfig": {
      "noMatchingService": "Nessuna decorazione corrispondente per la configurazione specificata",
      "wrongDimensions": "Dimensioni della decorazione non corrette"
    },
    "servicesPackageModify": "Modifica dimensioni e livello di complessità della decorazione",
    "servicesPackageVariant": "Variante selezionata",
    "servicesPackageName": "Nome del pacchetto decorazioni",
    "servicesPackagePopup": {
      "addServicesPackage": "Aggiungi pacchetto decorazioni",
      "includedServices": "Decorazioni incluse nel pacchetto selezionato:",
      "noServicesIncluded": "Nessuna decorazione assegnata al pacchetto selezionato.",
      "noServicesPackagesMatchingGivenPhrase": "Nessun pacchetto corrisponde alla ricerca",
      "selectServicesPackage": "Scegli il pacchetto decorazioni",
      "title": "Seleziona il pacchetto decorazioni da aggiungere"
    },
    "servicesPackageShowContents": "Mostra contenuto",
    "setupPrice": "Costo di Setup",
    "stitchNumber": "Numero di punti",
    "strandColors": "Colori dei fili",
    "wrongDimensions": "Dimensioni decorazione errate",
    "wrongDimensionsDesc": "È necessario inserire la larghezza e l'altezza della decorazione"
  },
  "settings": {
    "country": {
      "country": "Paese",
      "countryCode": "Codice paese",
      "selectCountry": "Seleziona il paese"
    },
    "currency": {
      "chooseCurrency": "Seleziona la valuta",
      "currency": "Valuta",
      "noCurrenciesAvailable": "Nessuna valuta disponibile..."
    },
    "language": {
      "chooseLanguage": "Seleziona la lingua",
      "noLanguagesAvailable": "Nessuna lingua disponibile"
    },
    "transaltion": {
      "addTranslation": "Aggiungi una traduzione",
      "addTranslationErrorText": "Aggiunta della traduzione non riuscita. Riprova.",
      "addTranslationSuccessText": "La traduzione inserita è stata salvata",
      "addTranslationSuccessTitle": "Traduzione aggiunta",
      "deleteTranslationConfirmTitle": "Vuoi davvero cancellare questa traduzione?",
      "deleteTranslationErrorText": "Cancellazione della traduzione non riuscita. Riprova.",
      "deleteTranslationSuccessText": "La traduzione selezionata è stata cancellata",
      "deleteTranslationSuccessTitle": "Traduzione cancellata",
      "editTranslation": "Modifica traduzione",
      "translationEditErrorText": "La modifica della traduzione non è riuscita. Riprova.",
      "translationEditSuccessText": "La traduzione selezionata è stata modificata",
      "translationEditSuccessTitle": "Traduzione modificata",
      "translations": "Traduzioni"
    }
  },
  "settlements": {
    "amount": "Importo",
    "deadlines": "Termini",
    "invoiceList": "Elenco delle fatture",
    "issued": "Emesso",
    "noSettlementsToDisplay": "Nessuna liquidazione da visualizzare",
    "paymentDueDate": "Pagamento entro",
    "settle": "Liquida",
    "settled": "Liquidato",
    "settlement": "Liquidazione",
    "settlements": "Liquidazioni",
    "type": "Tipo"
  },
  "shippers": {
    "chooseShipper": "Seleziona lo spedizioniere",
    "noShippersAvailable": "Nessuno spedizioniere disponibile"
  },
  "status": {
    "status": "Stato",
    "statusQuestionMark": "Stato?"
  },
  "translation": {
    "editTranslation": "Modifica traduzione",
    "languageLocative": "lingua",
    "languagesLocative": "lingue",
    "missingTranslationsIn": "Traduzione mancante in ",
    "noTranslationsToDisplay": "Nessuna traduzione disponibile...",
    "systemName": "Nome di sistema",
    "translated": "Tradotto",
    "translationEditErrorText": "Si è verificato un errore durante il salvataggio delle modifiche. Riprova...",
    "translationEditSuccessText": "Modifiche delle traduzioni salvate",
    "translationEditSuccessTitle": "Modifiche salvate",
    "translationStatus": "Stato della traduzione",
    "translations": "Traduzioni",
    "translationsTitle": "Elenco delle traduzioni",
    "valueInPolish": "In polacco"
  },
  "ui": {
    "actionFailedTryAgain": "Operazione fallita. Riprova.",
    "actions": "Azioni",
    "add": "Aggiungi",
    "addDescription": "Aggiungi descrizione",
    "addNew": "Aggiungi nuovo",
    "addToCart": "Aggiungi al carrello",
    "address": "Indirizzo",
    "allFieldsAreRequired": "Tutti i campi devono essere compilati",
    "amount": "Quantità",
    "availability": "Disponibilità",
    "back": "Torna",
    "backToList": "Torna alla lista",
    "cancel": "Annulla",
    "cart": "Carrello",
    "cartIsEmpty": "Il tuo carrello è vuoto",
    "chooseDate": "Seleziona data",
    "close": "Chiudi",
    "companyName": "Nome dell'azienda",
    "contactPerson": "Persona di contatto",
    "createOrderFromCart": "Crea ordine dai prodotti",
    "dataLoading": "Caricamento dati in corso",
    "dataLoadingFailed": "Il caricamento dei dati non è riuscito.",
    "daysOfWeek": {
      "fri": "Ven",
      "mon": "Lun",
      "sat": "Sab",
      "sun": "Dom",
      "thur": "Gio",
      "tue": "Mar",
      "wed": "Mer"
    },
    "deadlinePreferred": "Data preferita",
    "delete": "Cancella",
    "deleteConfirmText": "Quest’operazione non può essere annullata",
    "downloadInProgress": "Scaricamento in corso",
    "duplicate": "Duplica",
    "eMailCap": "E-mail",
    "eMailShort": "e-mail",
    "edit": "Modifica",
    "emailAddress": "Indirizzo e-mail",
    "errorOccured": "Si è verificato un errore",
    "errorOccuredDuringDownload": "Si è verificato un errore di download",
    "filtersSearch": "Ricerca",
    "generalInfo": "Dati generali",
    "importErrorTitle": "Si è verificato un errore durante l'importazione",
    "importFile": "Importa file",
    "importType": "Tipo di ingresso",
    "inCart": "Nel carrello",
    "invoiceNumber": "Numero della fattura",
    "isSettled": "Liquidati?",
    "lack": "Nessuno",
    "language": "Lingua",
    "leadingPerson": "Responsabile ordine",
    "loadError": "ERRORE DI CARICAMENTO",
    "markupProducts": "Ricarico sui prodotti",
    "markupServices": "Ricarico sulle decorazioni",
    "markupSetupServices": "Ricarico sul setup delle decorazioni",
    "markupShipping": "Ricarico sulla consegna",
    "monthNames": {
      "apr": "Apr",
      "aug": "Ago",
      "dec": "Dic",
      "feb": "Feb",
      "jan": "Gen",
      "jul": "Lug",
      "jun": "Giu",
      "mar": "Mar",
      "may": "Mag",
      "nov": "Nov",
      "oct": "Ott",
      "sep": "Set"
    },
    "myOrders": "I miei ordini",
    "name": "Denominazione",
    "nameAndSurename": "Nome e cognome",
    "no": "No",
    "noAvailabilityData": "Nessun dato sulla disponibilità",
    "notSettled": "Non liquidati",
    "ok": "OK",
    "okUnderstand": "OK, ho capito",
    "order": "Ordine",
    "orderName": "Nome dell'ordine",
    "pagination": {
      "itemsAmount": "Numero di posizioni:"
    },
    "partnerDiscountProducts": "Sconto cliente sui prodotti",
    "partnerDiscountServices": "Sconto cliente sulle decorazioni",
    "partnerDiscountShipping": "Sconto cliente sulla spedizione",
    "phoneShort": "tel.",
    "pieces": "Unità",
    "piecesAbbr": "un.",
    "piecesAmount": "Numero di unità",
    "productsGenitive": "Prodotti",
    "refNumber": "Numero di riferimento",
    "refreshPage": "Aggiorna la pagina",
    "repeatPassword": "Ripeti la password",
    "resetFilters": "Resetta i filtri",
    "saveChanges": "Salva modifiche",
    "search": "Cerca",
    "searchFrom": " cerca da",
    "searchTo": " a",
    "searching": "Ricerca in corso",
    "selectContactPerson": "Seleziona il contatto",
    "selectFile": "Seleziona file",
    "selectLeadingPerson": "Seleziona il responsabile dell'ordine",
    "selectedPersonNotFound": "Nessuna persona scelta",
    "settled": "Liquidati",
    "shipper": "Spedizioniere",
    "sorting": {
      "asc": "Crescente",
      "availability": "Disponibilità",
      "code": "Codice prodotto",
      "desc": "Decrescente",
      "label": "Ordina per",
      "price": "Prezzo"
    },
    "supplier": "Fornitore",
    "toTryAgain": "per riprovare.",
    "tryAgain": "Riprova",
    "value": "Valore",
    "viewInNewTab": "Vedi in una nuova scheda",
    "yes": "Sì",
    "yesRemove": "Sì, elimina"
  },
  "users": {
    "accountActive": "Account attivo",
    "accountInactive": "Account inattivo",
    "active": "Attivi",
    "addUser": "Aggiungi utente",
    "addUserErrorText": "L'aggiunta dell’utente non è riuscita. Riprova.",
    "addUserSuccessText": "L'utente specificato è stato salvato",
    "addUserSuccessTitle": "Utente aggiunto",
    "addingNewUser": "Aggiunta di un nuovo utente",
    "customer": "Cliente",
    "deleteConfirmTitle": "Vuoi davvero cancellare questo utente?",
    "deleteErrorText": "La cancellazione dell'utente non è riuscita. Riprova.",
    "deleteSuccessText": "L'utente selezionato è stato eliminato",
    "deleteSuccessTitle": "Utente cancellato",
    "editUser": "Modifica dell’utente",
    "editUserErrorText": "La modifica dell'utente non è riuscita. Riprova.",
    "editUserSuccessText": "L'utente selezionato è stato modificato",
    "editUserSuccessTitle": "L'utente è stato modificato",
    "inactive": "Inattivi",
    "isAccountActive": "Account attivo?",
    "loggedInAs": "Ha effettuato l’accesso come",
    "noUsersMatchingPhrase": "Nessun dipendente corrispondente alla stringa specificata",
    "noUsersToDisplay": "Nessun utente da visualizzare",
    "selectWorker": "Seleziona dipendente",
    "usersLabel": "Utenti",
    "usersList": "Elenco degli utenti",
    "usersSearchPlaceholder": "Inserisci il nome, il cognome o l’indirizzo email dell’utente"
  },
  "validation": {
    "fieldCanContainAtLeast1Char": "Questo campo deve contenere almeno un carattere",
    "fieldCanContainAtLeast24Chars": "Questo campo deve contenere almeno {min} caratteri",
    "fieldCanContainAtLeastNChars": "Questo campo deve contenere almeno {min} caratteri",
    "fieldCanContainAtMax1Char": "Questo campo può contenere al massimo un carattere",
    "fieldCanContainAtMax24Chars": "Questo campo può contenere al massimo {max} caratteri",
    "fieldCanContainAtMaxNChars": "Questo campo può contenere al massimo {max} caratteri",
    "onlyBigLetters": "Questo campo può contenere solo lettere maiuscole",
    "onlyLettersAndDashes": "Questo campo può contenere solo lettere e trattini",
    "onlyLettersAndNumbers": "Questo campo può contenere solo lettere e cifre",
    "onlyNumbers": "Questo campo deve contenere un numero",
    "onlyIntegerNumbers": "Questo campo deve contenere un numero intero",
    "passwordsAreNotIdentical": "Le password non sono identiche",
    "required": "Questo campo è obbligatorio",
    "validDoubleNumericRequired": "Il numero è richiesto in formato 123.45",
    "validEmailRequired": "Questo campo deve contenere un indirizzo e-mail valido",
    "validUrlRequired": "Questo campo deve contenere un indirizzo URL valido",
    "valueCannotBeGreaterThan": "Il valore non può essere maggiore di",
    "valueCannotBeLessThan": "Il valore non può essere minore di",
    "valueMustContainOrderID": "Il nome dell'ordine deve contenere l'ID dell'ordine:",
    "youMustSelectValue": "È necessario selezionare un valore"
  },
  "welcome": {
    "baseballCaps": "Cappellini con visiera",
    "capVizors": "Visiere",
    "choose": "Seleziona",
    "clear": "Cancella",
    "clientPanel": "Pannello cliente",
    "companyName": "Headwear",
    "filter": "Filtra",
    "filterAvailability": "Filtra disponibilità",
    "filterByNameOrCode": "Filtra per nome/codice",
    "filterByPrice": "Filtra per prezzo",
    "hats": "Cappelli",
    "noProductsInSearchCriteria": "Nessun prodotto che soddisfa i criteri forniti",
    "orderBy": "Ordina per",
    "orderInfo": "Realizza gli ordini <span class=\"text-primary font-weight-bold\">in 5 semplici passi</span>:",
    "productBrowserInfo": "Usa il nostro <span class=\"font-weight-bold\">browser dei prodotti</span>. Ci troverai le immagini dei prodotti, i prezzi e lo stato delle scorte. È anche possibile iniziare a creare un ordine dal motore di ricerca. Basta cliccare sul prodotto <span class=\"font-weight-bold\">\"Nel carrello\"</span>. Successivamente, puoi aggiungere l’intero carrello all’ordine.",
    "requireAll": "Richiedi tutti",
    "searchProducts": "Cerca prodotto",
    "setp": "Passo",
    "stepFiveContent": "Clicca il tasto <span class=\"font-weight-bold\">\"Salva offerta\"</span> o <span class=\"font-weight-bold\">\"Trasmetti l’ordine per la realizzazione\"",
    "stepFourContent": "Nella scheda <span class=\"font-weight-bold\">\"Dati generali\"</span>, inserisci i dati di consegna e di contatto",
    "stepOneContent": "Passa alla scheda <span class=\"font-weight-bold\">\"Ordine\"</span>",
    "stepThreeContent": "Nella scheda <span class=\"font-weight-bold\">\"Ordine\"</span>, seleziona i prodotti e le decorazioni.",
    "stepTwoContent": "Clicca il tasto <span class=\"font-weight-bold\">\"Aggiungi\"</span>",
    "wantToCheckOurProducts": "Vuoi controllare rapidamente i nostri prodotti e i nostri prezzi?",
    "welcomeToClientPanel": "Benvenuto/a nel pannello clienti HeadWear",
    "winterHats": "Cuffie invernali"
  }
};
